import formattedScheduleFunc from '@/helpers/shops/formattedSchedule'

export default (storesServices) => {
  const result = []
  if (storesServices?.length) {
    storesServices.forEach(item => {
      result.push({ ...item, scheduleObj: formattedScheduleFunc(item.schedule) })
    })
  }

  return result
}
